import React from 'react';

export default function ScheduleSection({ schedule = [] }) {
  if (schedule.length === 0) return null;

  return (
    <div className="containers-min mx-auto px-4 pb-12">
      <h3 className="font-gilroy mb-6">Schedule</h3>

      <div className="grid md:grid-cols-3 gap-6">
        {schedule.map((day) => (
          <div
            key={day.day}
            className="rounded-2xl border border-black/10 shadow-[0_0_15px_rgba(0,0,0,0.06)] bg-white overflow-hidden"
          >
            {/* Day header */}
            <div className="px-6 py-4 bg-[rgb(35,180,85)]/10 border-b border-black/5">
              <p className="font-gilroybold text-lg text-[rgb(35,180,85)]">
                {day.day}
              </p>
            </div>

            {/* Timeline */}
            <ul className="p-6 space-y-5">
              {day.items.map((item, i) => (
                <li key={i} className="relative pl-6">
                  {/* vertical line */}
                  {i !== day.items.length - 1 && (
                    <span className="absolute left-[5px] top-4 -bottom-5 w-px bg-black/10" />
                  )}
                  {/* dot */}
                  <span className="absolute left-0 top-1.5 h-[11px] w-[11px] rounded-full border-2 border-[rgb(35,180,85)] bg-white" />

                  <span className="inline-block whitespace-nowrap rounded-full bg-[rgb(35,180,85)]/10 px-3 py-1 font-poppins text-xs font-semibold text-[rgb(35,180,85)]">
                    {item.time}
                  </span>
                  <p className="mt-2 font-poppins text-sm text-black/80">
                    {item.activity}
                  </p>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}